export const dashboard = {
  professor: {
    title: 'Instructor panel',
    description: 'Production overview of your courses.',
    selecionarCurso: 'Select a course',
    cursoPlaceholder: 'Choose a course to see its metrics',
    semCursos: 'You don’t have any courses yet.',
    semSelecao: 'Select a course above to see consumption metrics.',
    metricas: {
      matriculados: 'Enrolled',
      matriculadosHint: 'Learners in the course population.',
      taxaConclusao: 'Completion rate',
      taxaConclusaoHint:
        'Counts those who completed (historical milestone), not those currently at 100%.',
    },
    quizzes: {
      title: 'Quiz averages',
      aula: 'Quiz lesson',
      media: 'Average (representative score)',
      tentantes: 'Attempted',
      empty: 'This course has no quiz lessons.',
    },
  },
  curador: {
    title: 'Curator panel',
    description: 'Tracking of your assignments.',
    abas: { trilha: 'Track', curso: 'Course' },
    selecionarTrilha: 'Select a track',
    trilhaPlaceholder: 'Choose a track',
    selecionarCurso: 'Select a course',
    cursoPlaceholder: 'Choose a course',
    semTrilhas: 'No tracks available.',
    semCursos: 'No courses available.',
    semSelecaoTrilha: 'Select a track above to see tracking.',
    semSelecaoCurso: 'Select a course above to see tracking.',
    recorteHint: 'Shows only the people you assigned.',
    contadores: {
      matriculados: 'Enrolled',
      concluidos: 'Completed',
      atrasados: 'Overdue',
      emRisco: 'At risk',
    },
  },
  admin: {
    title: 'Global overview',
    description: 'System-wide totals, without organizational slicing.',
    totais: {
      usuariosAtivos: 'Active users',
      trilhasAtivas: 'Active tracks',
      conclusoes: 'Completions',
    },
    busca: {
      title: 'Find user',
      placeholder: 'Search users by name or email...',
      ocioso: 'Type a name or email to find users.',
      vazio: 'No users found.',
      colunas: {
        nome: 'Name',
        email: 'Email',
        perfis: 'Roles',
        status: 'Status',
        acoes: 'Actions',
      },
      abrirGestao: 'Open in management',
    },
  },
} as const;
